import React from 'react';

import { FrequentPassageRequest } from '@legacy-types';

import { ApproveFrequentPassageRequestButton } from '@shared/frequent-passage-requests/components/ApproveFrequentPassageRequestButton';
import { DownloadFrequentPassageRequestVoucherButton } from '@shared/frequent-passage-requests/components/DownloadFrequentPassageRequestVoucherButton';
import { RedeemFrequentPassageRequestButton } from '@shared/frequent-passage-requests/components/RedeemFrequentPassageRequestButton';
import { RejectFrequentPassageRequestButton } from '@shared/frequent-passage-requests/components/RejectFrequentPassageRequestButton';

export type FrequentPassageRequestRowActionsProps = {
  frequentPassageRequest: FrequentPassageRequest;
  onActionComplete?: () => void;
};

export function FrequentPassageRequestRowActions({
  frequentPassageRequest,
  onActionComplete,
}: FrequentPassageRequestRowActionsProps) {
  return (
    <div className="flex flex-row items-center justify-end gap-2">
      {frequentPassageRequest.status === 'approved' && (
        <div className="flex flex-col gap-1">
          {frequentPassageRequest.canRedeem && (
            <RedeemFrequentPassageRequestButton
              frequentPassageRequest={frequentPassageRequest}
              onRedeem={onActionComplete}
            />
          )}

          <DownloadFrequentPassageRequestVoucherButton frequentPassageRequest={frequentPassageRequest} />
        </div>
      )}
      <div className="flex flex-col gap-1">
        <ApproveFrequentPassageRequestButton
          frequentPassageRequest={frequentPassageRequest}
          onApprove={onActionComplete}
        />
        <RejectFrequentPassageRequestButton
          frequentPassageRequest={frequentPassageRequest}
          onReject={onActionComplete}
        />
      </div>
    </div>
  );
}
